import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "pvc_token";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(undefined, (err) => {
  const d = err?.response?.data?.detail;
    if (err?.response?.status === 403 && typeof d === "string" && /^Your (store account|plan expired)/.test(d) && localStorage.getItem(TOKEN_KEY)) {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.setItem("pvc_auth_msg", d);
    if (window.location.pathname !== "/login") window.location.assign("/login");
  }
  return Promise.reject(err);
});

export const assetUrl = (src) => {
  if (!src) return "";
  return src.startsWith("/api/") ? `${BACKEND_URL}${src}` : src;
};

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd);
  return data.url;
}

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}
